import { OhsUser } from 'user/OhsUser';
import { withSignOffViewPermission, withCreatePermission } from 'global-services/OhsPermission';
import { ModuleUrl, ModuleRoute } from 'global-services/constants/OhsRoutes';
import { ModuleConfig } from 'global-services/constants/OhsObject';

const commonPermission = (user: OhsUser) => user?.configs?.incident?.PERMISSIONS.view || false;
const createRoute = (path: string, permission: (user: OhsUser) => boolean) => ({
  path,
  url: `/${ModuleUrl.Incident}/${path}`,
  permission,
});

const returnDefaultRoute = (user: OhsUser) => {
  const withView = commonPermission(user);
  if (withView) return createRoute('home', commonPermission);
  return createRoute('report', (u) => withCreatePermission(u, ModuleConfig.Incident));
};

const IncidentRouteList = {
  [ModuleRoute.Default]: (user: OhsUser) => returnDefaultRoute(user),

  [ModuleRoute.Home]: createRoute('home', commonPermission),
  [ModuleRoute.Add]: createRoute('report', (user) =>
    withCreatePermission(user, ModuleConfig.Incident)
  ),
  [ModuleRoute.Edit]: createRoute(':incidentId/report', commonPermission),
  [ModuleRoute.Details]: createRoute(':incidentId/view', commonPermission),
  [ModuleRoute.SignOff]: createRoute(':incidentId/task/sign-off/:taskId?', (user) =>
    withSignOffViewPermission(user, ModuleConfig.Incident)
  ),
  [ModuleRoute.Evidence]: createRoute(':incidentId/task/:taskId/completed', commonPermission),
  [ModuleRoute.LostTimeInjury]: createRoute('lti', commonPermission),
  [ModuleRoute.ImportManager]: createRoute('/lti/import', commonPermission),
};

export default IncidentRouteList;
